export enum MessageType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  CORRECTION = 'correction',
  INFO = 'info',
}
